import { PARTNER_SUBSCRIPTION_OFFER_USER_SOURCES } from '@core/constants/partner-subscription-offer.constants';

function normalizePartnerDeeplinkPath(path: string): string {
  return path.trim().toLowerCase().replace(/\/+$/, '');
}

/** Branch `$deeplink_path` for partner sign-up flow (`partner`; legacy `partner_referral` / `partner-referral`). */
export function isBranchPartnerSignUpDeeplink(path: string): boolean {
  const p = normalizePartnerDeeplinkPath(path);
  return p === 'partner' || p.includes('partner_referral') || p === 'partner-referral';
}

/** `source` values for which we persist signup attribution in a cookie (30-day). */
export function isBranchPartnerSignupCookieSource(source: string | null): boolean {
  const s = (source ?? '').trim().toLowerCase();
  return !!s && PARTNER_SUBSCRIPTION_OFFER_USER_SOURCES.includes(s);
}

export function getBranchLinkSource(parsed: BranchDataParsed): string | null {
  const meta = parsed.$custom_meta_tags;
  const fromRoot = typeof parsed.source === 'string' && parsed.source.trim() ? parsed.source.trim() : null;
  const fromMeta = typeof meta?.source === 'string' && meta.source.trim() ? meta.source.trim() : null;
  return fromRoot ?? fromMeta ?? null;
}

export interface BranchDataParsed {
  $deeplink_path?: string;
  /** Partner links; also check `$custom_meta_tags.source`. */
  source?: string;
  $custom_meta_tags?: {
    source?: string;
    token?: string;
    bookingEventId?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}
